import { IGesundheitsProgrammInfo, IPartnerInfo } from '../mgs.types';
import { htmlOut, sortArray } from '@mng/mng-ts-helpers';
import { isApiAbschlussProgramm } from '../programm/programm-helper';

export const PARTNER_MERKUR = 1;
export const PARTNER_MERKUR_LIFESTYLE = 3;
export const PARTNER_FALKENSTEINER_BUCHUNG = 9;

export function getPartnerInfoAsString(partner: IPartnerInfo, detailInfo = false): string {
  if (!partner) {
    return '-';
  }
  let out = `${partner.name}`;
  if (detailInfo) {
    const betriebstellenkeyOut = partner.betriebstellenkey ? `${partner.betriebstellenkey},` : '';
    out += ` (${betriebstellenkeyOut ?? ''} ID: ${partner.id})`;
  }

  return out;
}

export function partnerInfoHtmlDetailAsString(partner: IPartnerInfo, detailInfo = false): string {
  if (!partner) {
    return '-';
  }

  let detailInfoHtml = '';
  if (detailInfo) {
    detailInfoHtml = `
        ${partner.betriebstellenkey ? htmlOut('BSK', partner.betriebstellenkey) : ''}
        ${htmlOut('Partner ID', partner.id)}
    `;
  }

  return `
        ${htmlOut('Partner', partner.name)}
        ${detailInfoHtml}
      `;
}

export interface PartnerFilter {
  ohneInaktive: boolean;
  hotelPartner: boolean;
  studioPartner: boolean;
  institutPartner: boolean;
  nurMitBuchungPartnerID: number | undefined;
  buchungPartner?: boolean; // für Admin -> alle Buchung Partner
}

export const defaultPartnerFilter: PartnerFilter = {
  ohneInaktive: true,
  hotelPartner: true,
  studioPartner: true,
  institutPartner: true,
  nurMitBuchungPartnerID: undefined
};

export const abrechnungPartnerFilter: PartnerFilter = {
  ohneInaktive: true,
  hotelPartner: true,
  studioPartner: false,
  institutPartner: false,
  nurMitBuchungPartnerID: undefined
};

export function filterUndSortPartnerNachPartnerTypUndName(
  partnerList: IPartnerInfo[],
  filter: PartnerFilter = defaultPartnerFilter
): IPartnerInfo[] {
  const partnerSort = (partner: IPartnerInfo) => {
    const name = partner.name ?? '';
    if (partner.betriebstellenkey) {
      if (isHotelPartner(partner)) {
        return 1 + name;
      } else if (isFitnessOrYogaPartner(partner)) {
        return 2 + name;
      } else if (isInstitutPartner(partner)) {
        return 3 + name;
      }
    }
    return 9 + name;
  };

  if (filter.ohneInaktive || !filter.hotelPartner || !filter.institutPartner || !filter.studioPartner) {
    partnerList = partnerList.filter((partner) => {
      let result = true;

      if (filter.ohneInaktive && partner.inaktiv) {
        result = false;
      }

      if (filter.buchungPartner && !partner.buchungPartner) {
        return false;
      }

      if (
        filter.nurMitBuchungPartnerID &&
        (!partner.buchungPartner || partner.buchungPartner !== filter.nurMitBuchungPartnerID)
      ) {
        result = false;
      }

      if (result && !filter.hotelPartner && isHotelPartner(partner)) {
        result = false;
      }

      if (result && !filter.studioPartner && isFitnessOrYogaPartner(partner)) {
        result = false;
      }

      if (result && !filter.institutPartner && isInstitutPartner(partner)) {
        result = false;
      }

      return result;
    });
  }

  return sortArray(partnerList, partnerSort);
}

export function isCodePruefungPartner(partner: IPartnerInfo, programme: IGesundheitsProgrammInfo[]) {
  return (isHotelPartner(partner) || isInstitutPartner(partner)) && !isApiAbschlussPartner(programme);
}

export function isHotelPartner(partner: IPartnerInfo) {
  return 'HOT' === partner?.art;
}

export function isPartnerMerkur(partner: IPartnerInfo) {
  return PARTNER_MERKUR === partner.id;
}

export function isPartnerMerkurLifestyle(partner: IPartnerInfo) {
  return PARTNER_MERKUR_LIFESTYLE === partner.id;
}

export function isFitnessOrYogaPartner(partner: IPartnerInfo) {
  return 'FIT' === partner?.art;
}

export function isInstitutPartner(partner: IPartnerInfo) {
  return 'INS' === partner?.art;
}

export function isApiAbschlussPartner(programme: IGesundheitsProgrammInfo[]) {
  return programme?.some((programm) => isApiAbschlussProgramm(programm.id as number)); // id ist immer defined
}
